import React, { useEffect, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";
import LeadFollowUpsList from "./LeadFollowUpsList";
import DealFollowUpsList from "./DealFollowUpsList";
import { MdFilterListAlt } from "react-icons/md";
import FollowUpsFilter from "./FollowUpsFilter";
import propertyService from "../Services/PropertyService";
import teamService from "../Services/TeamService";
import { userRole } from "../../utils/storage";
import CustomSelect from "../common/CustomSelect";
import CustomChip from "../common/CustomChip";
import { MdOutlineCancel } from "react-icons/md";
import { formatToIndianDate } from "../../utils/dateFormatter";

const FollowUpsMain = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [filterStartDate, setFilterStartDate] = useState(today || null);
  const [filterEndDate, setFilterEndDate] = useState(today || null);
  const tabs = ["Lead Follow Ups", "Deal Follow Ups"];
  const [startType, setStartType] = useState("");

  const handleApplyFilter = () => {
    setIsFilterOpen(false);
    setFilterStartDate(startDate);
    setFilterEndDate(endDate);
  };

  const [teams, setTeams] = useState([{ name: null, id: "All Team" }]);
  const [selectedUser, setSelectedUser] = useState("");
  const [properties, setProperties] = useState([
    { name: "All Property", id: "All Property" },
  ]);
  const [users, setUsers] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [tempSelectedTeam, setTempSelectedTeam] = useState("");
  const userData = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    (async () => {
      try {
        if (userRole === "Admin" || userRole === "CMO") {
          const response = await teamService.getTeamName();
          setTeams([...response.data.teams]);
        } else if (userRole === "MD") {
          setTeams(userData.teamId);
          setTempSelectedTeam();
        }

        if (selectedTeam) {
          let response = {};
          if (userRole !== "BOD") {
            response = await teamService.getTeamData(selectedTeam);
          }

          const data = response.data;

          const combinedUsers = [
            ...(Array.isArray(data.BOD) && data.BOD.length > 0
              ? data.BOD.map((bod) => ({ name: bod.name, id: bod.id }))
              : []),
            ...(data.MD && data.MD.name !== null && data.MD.id !== null
              ? [{ name: data.MD.name, id: data.MD.id }]
              : []),
            ...(Array.isArray(data.members) && data.members.length > 0
              ? data.members.map((member) => ({
                  name: member.name,
                  id: member.id,
                }))
              : []),
          ];

          const finalUsers = combinedUsers.length > 0 ? combinedUsers : [];
          setUsers(finalUsers);
        } else {
          const userResponse = await teamService.getUserName();
          setUsers(userResponse.data.users);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    })();
  }, [selectedTeam]);

  console.log(selectedUser);

  const clearFilters = () => {
    setSelectedUser(null);
    setSelectedTeam(null);
    setStartDate(today);
    setEndDate(today);
    setFilterStartDate(today);
    setFilterEndDate(today);
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleRemove = () => {
    clearFilters();
  };

  return (
    <div className="bg-appGrayBackground min-h-screen">
      <AdminAppBar />

      <div className="px-6 pt-28">
        <div className="flex justify-between items-center mb-6">
          <div className="flex ">
            {tabs.map((tab, index) => (
              <button
                key={index}
                className={`py-2 px-4 text-xl  font-medium focus:outline-none ${
                  activeTab === index
                    ? "border-b-4  border-customGreen text-customGreen"
                    : "text-gray-500 hover:text-bcustomGreen"
                }`}
                onClick={() => {
                  setActiveTab(index);
                  setSelectedUser(null);
                  setSelectedTeam(null);
                  setStartType("");
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-4">
            {(startDate || endDate) && (
              <div className="flex items-center gap-2 px-3 py-1 rounded-full border border-customGreen bg-white text-customGreen text-sm transition-all duration-150">
                <span className="truncate">
                  <span>{`Date: ${formatToIndianDate(
                    startDate
                  )} - ${formatToIndianDate(endDate)}`}</span>
                </span>
                <button
                  onClick={handleRemove}
                  className="text-customGreen hover:bg-customGreen hover:text-white rounded-full p-1 transition-all duration-150"
                  aria-label="Remove date filter"
                >
                  <MdOutlineCancel className="text-lg" />
                </button>
              </div>
            )}

            {userRole !== "BOD" && (
              <div className="flex w-52 items-center gap-4">
                <CustomSelect
                  value={selectedUser}
                  options={users.map((list) => ({
                    value: list.id,
                    label: list.name,
                  }))}
                  onChange={(user) => setSelectedUser(user)}
                  placeholder="Select user"
                />
              </div>
            )}
            <div className="flex items-center gap-4">
              <button
                onClick={() => {
                  setIsFilterOpen(!isFilterOpen);
                }}
                className="bg-white  justify-between text-base font-medium w-[131px] h-[50px] rounded-[10px]   flex items-center gap-3 text-customGreen py-2 px-4  hover:bg-appGreenHover transition duration-300"
              >
                Filters
                <MdFilterListAlt />
              </button>
            </div>
          </div>
        </div>

        <div className="mt-6">
          {activeTab === 0 && (
            <LeadFollowUpsList
              activeTab={activeTab}
              startDate={filterStartDate}
              endDate={filterEndDate}
              selectedTeam={selectedTeam}
              setSelectedTeam={setSelectedTeam}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              refreshTrigger={refreshTrigger}
            />
          )}
          {activeTab === 1 && (
            <DealFollowUpsList
              startDate={filterStartDate}
              endDate={filterEndDate}
              userList={users}
              selectedTeam={selectedTeam}
              setSelectedTeam={setSelectedTeam}
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
              refreshTrigger={refreshTrigger}
            />
          )}
        </div>
      </div>
      <FollowUpsFilter
        visible={isFilterOpen}
        onHide={() => {
          setIsFilterOpen(false);
        }}
        setEndDate={setEndDate}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        handleApplyFilter={handleApplyFilter}
        clearFilters={clearFilters}
        setStartType={setStartType}
        startType={startType}
      />
    </div>
  );
};

export default FollowUpsMain;
